import {
  VerificationLevel,
  VerificationLevels
} from "@wingspanhq/wingspan-api-sdk";

export const selectorIsEntityVerified = (verifications: VerificationLevels) => {
  const isSomeMainVerified =
    verifications.tax === VerificationLevel.VERIFIED ||
    verifications.banking === VerificationLevel.VERIFIED ||
    verifications.enhanced === VerificationLevel.VERIFIED;

  const isSomeProfileVerified = verifications.profiles
    ? Object.values(verifications.profiles).some(
        profile => profile.tax === VerificationLevel.VERIFIED
      )
    : false;

  return isSomeMainVerified || isSomeProfileVerified;
};
